import React, { useState } from "react"
import { useEffect } from "react"

const Permissions = ({ data, setData }) => {
    let permissions = Object.keys(data)
    var checkedList = []
    Object.keys(data).forEach((permission) =>  {
        if(data[permission]) {
            checkedList.push(permission)
        }
    })
    const [checked, setChecked] = useState(checkedList)
    const [checkboxes, setCheckboxes] = useState("")

    const handleCheck = (event) => {
        data[event.target.value] = event.target.checked
        setData(data)

        var updatedList = [...checked]
        if (event.target.checked) {
            updatedList = [...checked, event.target.value]
        } else {
            updatedList.splice(checked.indexOf(event.target.value), 1)
        }
        setChecked(updatedList)
    }

    function getPermissionLabel(permission) {
        let label = ""
        permission.split("_").forEach(element => {
            label += element.charAt(0).toUpperCase() + element.substring(1) + " "
        })
        return label
    }

    function updateCheckboxes() {
        setCheckboxes(
            permissions.map((permission) => (
                <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2" key={permission}>
                    <div className="icheck-primary">
                        <input type="checkbox" id={permission} value={permission} checked={checked.includes(permission)} onChange={handleCheck} />
                        <label htmlFor={permission} style={{margin: "10px"}}>
                            {" " + getPermissionLabel(permission)}
                        </label>
                    </div>
                </div>
            ))
        )
    }

    useEffect(() => {
        updateCheckboxes()
    }, [data, checked])

    useEffect(() => {
        var checkedList = []
        Object.keys(data).forEach((permission) =>  {
            if(data[permission]) {
                checkedList.push(permission)
            }
        })
        setChecked(checkedList)
    }, [data])
  
    return (<>
        <div className="row">
            <h4>Permissions</h4>
        </div>
        <div className="row">
            {checkboxes}
        </div>
    </>)
}

export default Permissions